<template>
  <div id="data-view">
    <dv-full-screen-container>
      <!--头部-->
      <topHeader></topHeader>
      <!--主-->
      <dv-border-box-1 class="main-container">
        <!--左-->
        <div class="left-chart-container box box_v">

          <div class="dc-text box box_v">
            美食林集团
            <dv-decoration-3/>
          </div>
          <dv-border-box-13 class="dc-text-content">
            <div class="box box_around">
              <div class="box box_v box_i_center">
                <div class="dc-text-title">消费</div>
                <div class="dc-text-num">{{toThousands(mslGroup.goodsAmount, true)}}元</div>
              </div>
              <div class="box box_v box_i_center">
                <div class="dc-text-title">商场核销</div>
                <div class="dc-text-num">{{toThousands(mslGroup.consumeNumMall, true)}}张</div>
              </div>

              <div class="box box_v box_i_center">
                <div class="dc-text-title">超市核销</div>
                <div class="dc-text-num">{{toThousands(mslGroup.consumeNumMarket, true)}}张</div>
              </div>

            </div>
          </dv-border-box-13>

          <!--排行榜-->
          <div class="box_f1">
            <div class="phb">
              <csscTable :type="'msljt'"></csscTable>
              <csscAllTable :type="'supermarket'" :title="'超市总排行'"></csscAllTable>
            </div>
          </div>

        </div>
        <!--中-->
        <div class="center-chart-container">

          <div class="rmc-top-container">
            <centerCmp></centerCmp>
          </div>

          <!--统计图-->
          <div class="rmc-center-container">
            <centerCharts></centerCharts>
          </div>


        </div>
        <!--右边-->
        <div class="right-chart-container box box_v">

          <div class="dc-text box box_v box_i_end">
            阳光集团
            <dv-decoration-3/>
          </div>

          <dv-border-box-13>
            <div class="box box_around">
              <div class="box box_v box_i_center">
                <div class="dc-text-title">消费</div>
                <div class="dc-text-num">{{toThousands(sunGroup.goodsAmount, true)}}元</div>
              </div>

              <div class="box box_v box_i_center">
                <div class="dc-text-title">商场核销</div>
                <div class="dc-text-num">{{toThousands(sunGroup.consumeNumMall, true)}}张</div>
              </div>

              <div class="box box_v box_i_center">
                <div class="dc-text-title">超市核销</div>
                <div class="dc-text-num">{{toThousands(sunGroup.consumeNumMarket, true)}}张</div>
              </div>

            </div>
          </dv-border-box-13>


          <!--排行榜-->
          <div class="box_f1">
            <div class="phb">
              <csscTable :type="'ygjt'"></csscTable>
              <csscAllTable :type="'hypermarket'" :title="'商场总排行'"></csscAllTable>
            </div>
          </div>

        </div>

      </dv-border-box-1>
    </dv-full-screen-container>
  </div>
</template>

<script>
    import Vue from "vue";
    import topHeader from "./topHeader"
    import centerCharts from "./centerCharts"
    import centerCmp from "./centerCmp"
    import csscTable from './csscTable'
    import csscAllTable from './csscAllTable'
    import {  fullScreenContainer, borderBox1, borderBox6, borderBox8, borderBox9, borderBox13,
              decoration1, decoration3, decoration5, decoration7, decoration8, decoration10,
              charts, scrollBoard, loading } from '@jiaminghi/data-view'
    Vue.use(fullScreenContainer)
    Vue.use(loading)
    Vue.use(borderBox1)
    Vue.use(borderBox6)
    Vue.use(borderBox8)
    Vue.use(borderBox9)
    Vue.use(borderBox13)
    Vue.use(decoration1)
    Vue.use(decoration3)
    Vue.use(decoration5)
    Vue.use(decoration7)
    Vue.use(decoration8)
    Vue.use(decoration10)
    Vue.use(scrollBoard)
    Vue.use(charts)
    export default {
        name: "mainPage",
        computed: {
          xiaofeiquanVue() {
            return this.$store.state.xiaofeiquanVue
          },
        },
        data() {
          return {
            mslGroup: {
              consumeNumMall: 0,
              consumeNumMarket: 0,
              goodsAmount: 0,
              groupName: "美食林集团"
            },
            sunGroup: {
              consumeNumMall: 0,
              consumeNumMarket: 0,
              goodsAmount: 0,
              groupName: "阳光集团"

            }
          }
        },
        created() {
            this.load()
        },
        methods: {
          load() {
            //美食林、阳光集团统计总和
            this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/group',{},request=> {
              if(request.newPrimaryKeys) {
                if(request.newPrimaryKeys.sunGroup) {
                  this.sunGroup = request.newPrimaryKeys.sunGroup
                }
                if(request.newPrimaryKeys.mslGroup) {
                  this.mslGroup = request.newPrimaryKeys.mslGroup
                }
                if(request.newPrimaryKeys.goodsAmount) {
                  this.mslGroup = request.newPrimaryKeys.goodsAmount
                }
              }
            })
          },
          toThousands(num, bol) {
            num = parseInt(num)
            let result = [ ], counter = 0;
            num = (num || 0).toString().split('')
            for (let i = num.length - 1; i >= 0; i--) {
              counter++
              result.unshift(num[i])
              if (!(counter % 3) && i != 0) { result.unshift(','); }
            }
            if(bol) {
              return result.join('')
            }else {
              return result
            }
          }
        },
        components: { topHeader, centerCmp, centerCharts, csscTable, csscAllTable }
    }
</script>

<style lang="less">
  @import "img/index.css";
  #data-view {
    width: 100%;
    height: 100%;
    background-color: #030409;
    color: #fff;
    #dv-full-screen-container {
      background-image: url('./img/guang1.png'), url('./img/bg.jpg');
      background-size: 110% 70%, 100% 100%;
      background-position: center top, center top, center;
      background-repeat: no-repeat;
      box-shadow: 0 0 3px blue;
      display: flex;
      flex-direction: column;

    }
    .main-container {
      height: 100%;
      .border-box-content {
        position: relative;
        padding: 20px;
        box-sizing: border-box;
        display: flex;
      }
    }
    .left-chart-container, .right-chart-container {
      width: 32%;
      height: 100%;
      /*padding: 0 10px;*/
      position: relative;
      box-sizing: border-box;
      .border-box-content {
        flex-direction: column;
      }

      .dv-border-box-13 {
        height: 90px;
      }

      .dc-text-title {
          font-size: 16px;
      }

      .dc-text-num {
        font-size: 18px;
        margin-top: 5px;
        color: rgb(255, 252, 134);
      }
    }
    .phb {
      width: 100%;
      height: 100%;
      padding: 0;
      margin: 0;
      position: relative;
      box-sizing: border-box
    }
    .dc-text {
      font-size: 18px;
      .dv-decoration-3 {
        width: 100px;
        height: 20px;
      }
    }

    .center-chart-container {
      width: 36%;
      padding: 0 10px 10px 10px;
      box-sizing: border-box;
      position: relative;
      .border-box-content {
        position: relative;
        flex-direction: column;
      }

      .rmc-top-container {
        position: relative;
        height: 30%;
        display: flex;
      }
      .rmc-center-container {
        position: relative;
        height: 70%;
      }
    }
  }
</style>
